import { EXPORT_INTEGRATION_IDS, INTEGRATION_IDS } from './constants';
import {
  ExportIntegrationId,
  IntegrationId,
} from 'integrations/common/streams/tabularMappings/types';

export const isIntegrationId = (
  integrationId: string | null
): integrationId is IntegrationId =>
  Boolean(integrationId) &&
  INTEGRATION_IDS.includes(integrationId as IntegrationId);

export const isExportIntegrationId = (
  integrationId: string | null
): integrationId is ExportIntegrationId =>
  Boolean(integrationId) &&
  EXPORT_INTEGRATION_IDS.includes(integrationId as ExportIntegrationId);
